@if (!time() || !unit()) {
  -
} @else {
  @if (isHours) {
    {{ time() * (minutesToHours() ? 60 : 1) | totalMinutesFormat }}
  } @else if (isDays) {
    {{ time() | number }} {{ time() | i18nPlural: daysPluralMapping }}
  } @else {
    {{ time() | number }} {{ time() | i18nPlural: weekPluralMapping }}
  }
}
